import SEOHead from "@/components/SEOHead";
import { useI18n } from "@/i18n/I18nContext";
import { getPageSeo } from "@/i18n/pageSeo";

type Props = Omit<React.ComponentProps<typeof SEOHead>, "title" | "description"> & {
  page: Parameters<typeof getPageSeo>[1];
  title?: string;
  description?: string;
};

/** SEOHead with per-language title/description taken from the page SEO dictionary. */
export default function PageSeo({ page, title, description, ...rest }: Props) {
  const { lang } = useI18n();
  const seo = getPageSeo(lang, page);
  return <SEOHead title={title || seo.title} description={description || seo.description} {...rest} />;
}
